import { PaymentMethodEnum } from 'common/enums/PaymentMethodEnum'
import { Coupon } from 'common/types/CouponType'
import {
  ProductInterface,
  ProductVariantInterface,
} from 'common/types/entities/ProductInterface'
import { PricePlan } from 'common/types/OfferInterface'
import { OfferPricing } from 'common/types/pricingTypes'
import { CalculatePriceData } from 'common/types/shippingType'
import { fetchOfferPricing } from 'publisher/pages/offer-page/utils/fetchOfferPricing'

export interface GetOfferPricing {
  product: ProductInterface | null
  productBump?: ProductInterface | null
  pricePlans: PricePlan[]
  bumpPlan?: PricePlan
  bumpOfferId?: number
  offerId: number
  productQuantity: number
  activeProductVariant: ProductVariantInterface | null
  country?: string
  coupon?: Coupon
  taxNumber?: string
  paymentMethod?: PaymentMethodEnum | null

  abortSignal?: AbortSignal
}

export const calculateOfferPricing = async ({
  product,
  productBump,
  pricePlans,
  bumpPlan,
  bumpOfferId,
  offerId,
  productQuantity,
  activeProductVariant,
  country,
  coupon,
  taxNumber,
  paymentMethod,

  abortSignal,
}: GetOfferPricing): Promise<OfferPricing[]> => {
  if (!offerId || (!product?.id && !pricePlans.length)) return []

  const offers: CalculatePriceData[] = pricePlans.map(pricePlan => ({
    quantity: 1,
    offer: offerId,
    coupon: coupon?.id || null,
    pricePlan: pricePlan.id,
    country: country || null,
    taxNumber,
    paymentMethod,
  }))

  // may or may not be included in general price plans list
  if (
    bumpPlan &&
    bumpOfferId &&
    !pricePlans.some(pp => pp.id === bumpPlan.id)
  ) {
    offers.push({
      quantity: 1,
      offer: bumpOfferId,
      pricePlan: bumpPlan.id,
      // bumps are a special case with coupon not being applicable
      coupon: null,
      country: country || null,
      taxNumber,
      paymentMethod,
    })
  }

  if (product?.id) {
    offers.push({
      product: product?.id,
      productVariant: activeProductVariant?.id,
      quantity: productQuantity,
      offer: offerId,
      coupon: coupon?.id || null,
      country: country || null,
      taxNumber,
      paymentMethod,
    })
  }

  if (productBump?.id && bumpOfferId) {
    offers.push({
      product: productBump?.id,
      quantity: 1,
      offer: bumpOfferId,
      // bumps are a special case with coupon not being applicable
      coupon: null,
      country: country || null,
      taxNumber,
      paymentMethod,
    })
  }

  const newOfferPricings = await fetchOfferPricing(offers, abortSignal)

  return newOfferPricings
}
